import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export const APP_DIALOG_MAX_HEIGHT = 'calc(100dvh - 2rem)';

/** Defaults DynamicDialog PrimeNG (masque, Esc, hauteur max viewport). */
export function appDialogDefaults(
	overrides: Partial<DynamicDialogConfig> = {},
): Partial<DynamicDialogConfig> {
	const closable = overrides.closable ?? true;
	const closeOnEscape = overrides.closeOnEscape === undefined
		? closable
		: overrides.closeOnEscape !== false;
	const dismissableMask = overrides.dismissableMask === undefined
		? closable
		: overrides.dismissableMask !== false;

	return {
		modal: true,
		dismissableMask,
		autoZIndex: true,
		baseZIndex: 1100,
		duplicate: true,
		draggable: false,
		styleClass: 'app-dynamic-dialog',
		contentStyle: {
			padding: 0,
			overflow: 'hidden',
			display: 'flex',
			flexDirection: 'column',
			width: '100%',
			maxHeight: APP_DIALOG_MAX_HEIGHT,
		},
		...overrides,
		closeOnEscape,
		closable,
	};
}
